import styled from 'styled-components';

const Subtitle = styled.h2`
    color: rgba(0, 0, 0, 0.8);
    font-size: 1.5em;
    font-weight: normal;
    margin: 0;
    padding: 0;
`;

export default Subtitle;
